import { sanitizeInput } from '@shared/utils/sanitize-input/sanitizeInput';
import { z } from 'zod';

const sanitize = (v: unknown): string =>
  sanitizeInput(typeof v === 'string' ? v : undefined) ?? '';

export const editContactSchema = z.object({
  mobileNumber: z.preprocess(sanitize, z.string()),
});

export type EditContactFormData = z.infer<typeof editContactSchema>;
